export const en = {
    'check-phrases-and-groups-settings': 'Check the keywords and ad group settings.',
    'check-show-conditions':
        'Change your retargeting criteria, do not use operators to restrict keywords, edit the list of keywords to match demand in your region, and increase your bid for impressions in ad networks. This will make your ads more likely to win the auction.',
    'many-group-title': 'Adjust {count} groups with low estimated impressions',
    'one-group-title': 'Correct {count} group with low estimated impressions',
    'one-group-title-hint': 'The recommendation is shown because of low estimated impressions for the group',
    'several-group-title-hint':
        'The recommendation is shown because some groups are going to have low estimated impressions',
    'show-many-group-button': 'View {count} groups',
    'show-one-group-button': 'View {count} group',
    'show-some-group-button': 'View {count} groups',
    'simple-title': "The group's ads are not served or are rarely served. Try adjusting settings.",
    'some-group-title': 'Adjust {count} groups with low estimated impressions',
    'twenty-one-group-title': 'Adjust {count} group with low estimated impressions'
};
